import { FriendGroupType } from './friend'
import { GenericPaginatedListResponse, GenericResponse } from './main'

export enum DailyLogDiaryType {
  IMAGE = 'IMAGE',
  SIMPLE_THOUGHT = 'SIMPLE_THOUGHT',
  LINK = 'LINK',
  KEYWORD = 'KEYWORD', //deprecated
  EMOTION = 'EMOTION',
  ESSAY = 'ESSAY',
  TODAY_TOPIC = 'TODAY_TOPIC', //deprecated
  LETTER = 'LETTER', //deprecated
  PHOTO = 'PHOTO',
  TEMPLATE = 'TEMPLATE',
}

export enum DailyLogTraversalType {
  NOT_VIEWED = 'NOT_VIEWED',
  VIEWED = 'VIEWED',
}

export enum DailyLogReactionType {
  MEMO = 'MEMO',
  BIG_MEME = 'BIG_MEME',
  SMALL_MEME = 'SMALL_MEME',
  EMOJI = 'EMOJI',
  STICKER = 'STICKER',
  USER_RECOMMEND = 'USER_RECOMMEND',
  GIPHY = 'GIPHY',
}

export enum DailyLogMemeType {
  BIG_MEME = 'BIG_MEME',
  SMALL_MEME = 'SMALL_MEME',
  RECENT = 'RECENT',
  POPULAR = 'POPULAR',
  TEMPLATE = 'TEMPLATE',
  USER_RECOMMEND = 'USER_RECOMMEND',
  GIPHY = 'GIPHY',
}

export type DailyLogTemplate = {
  id: number
  bgImageUrl: string
  title?: string
  exampleId?: number
  label?: string
}

export type DailyLogSelectedReaction = {
  id?: number | string // (meme, sticker, emoji id: number), (giphy id: string)
  type: DailyLogReactionType
  isTemplateSticker?: boolean
  content: string
  // 이하 memo 이외 타입일 경우 필요한 필드
  width?: number
  height?: number
  isRoundBordered?: boolean
  x?: number
  y?: number
  scale?: number
  angle?: number
}

export type DailyLogAnalysisEmotion = {
  name: string
  point: number
}

export type DailyLogAnalysisSong = {
  title: string
  singer: string
  reason: string
}
export type DailyLogAnalysisPhrase = {
  content: string
  writer: string
  book: string
}

export type DailyReview = {
  content: string
}

export type DailyLogAnalysis = {
  emotions: DailyLogAnalysisEmotion[]
  song: DailyLogAnalysisSong
  phrase: DailyLogAnalysisPhrase
  dailyReview: DailyReview
}

export type DailyLogReaction = {
  id: number
  memo: string
  profileImageUrl: string
  imageUrl: string
  type: DailyLogReactionType
  location: {
    heightRatio: number
    widthRatio: number
  }
  name: string
  scale: number
  rotate: number
  commentCount: number
  isMine: boolean // 내가 작성했는지 여부
  createdAt: string
  userId: number
  isAnonymous: boolean
  isHintAvailable: boolean
  anonymousNumber: string
  isPrivate: boolean
  // 이하 memo 이외 타입일 경우 필요한 필드
  width?: number
  height?: number
  isRoundBordered?: boolean
}

export type DailyLogPost = {
  id: number
  type: DailyLogDiaryType
  link?: string
  name: string
  anonymousNumber?: string
  profileImageUrl: string
  isNickUsed: boolean
  content: string
  postedAt: string
  imageUrl: string
  deletionReservedAt: string
  userId: number
  nextPostId: number
  prevPostId: number
  title: string
  schoolInfo: string
  analysisResult?: DailyLogAnalysis
  keyword?: string
  viewCount?: number
  reactions: DailyLogReaction[]
  isPrivate?: boolean
  bgImageId?: number
  bgColor?: string
  template?: DailyLogTemplate
  isReactionPrivate: boolean
}

export type DailyLogPostUpdateBody = {
  type?: DailyLogDiaryType
  link?: string
  content?: string
  image?: File | ''
  keyword?: string
  postedAt?: string
  bgImageId?: number
  bgColor?: string
  isReactionPrivate?: boolean
}

export type DailyLogPostResponse = GenericResponse & {
  data: DailyLogPost
}

/* 밈, 이모지, 스티커 */
export type DailyLogAsset = {
  id: number | string
  imageUrl: string
  type?: DailyLogReactionType
  // 이하 memo 이외 타입일 경우 필요한 필드
  width: number
  height: number
  isRoundBordered: boolean
}

export type DailyLogEmoji = DailyLogAsset
export type DailyLogSticker = DailyLogAsset
export type DailyLogMeme = DailyLogAsset

export type DailyLogMemeListResponse = GenericPaginatedListResponse & {
  data: {
    memes: DailyLogMeme[]
    totalCount: number
  }
}

export type DailyLogTemplateMemeListResponse = GenericPaginatedListResponse & {
  data: {
    label: string
    memes: DailyLogMeme[]
    totalCount: number
  }
}

export type DailyLogEmojiListResponse = GenericPaginatedListResponse & {
  data: {
    emojis: DailyLogEmoji[]
    totalCount: number
  }
}

export type DailyLogReactionResponse = GenericResponse & {
  data: DailyLogReaction
}

export type DailyLogReactionCreateBody = {
  giphyUniqueId?: number | string
  memo?: string
  memeId?: number
  stickerId?: number
  emojiId?: number
  locationHeightRatio: number
  locationWidthRatio: number
  scale?: number
  rotate?: number
  nickname?: string
  isPrivate?: boolean
  userIdentifier?: string
}

export type DailyLogReactionUpdateBody = {
  memo?: string
  memeId?: number
  stickerId?: number
  emojiId?: number
  locationHeightRatio?: number
  locationWidthRatio?: number
  scale?: number
  rotate?: number
}

export type DailyLogEditProBackgroundImage = {
  id: number
  url: string
  thumbnailUrl: string
}

export type DailyLogEditProBackgroundImageResponse = GenericResponse & {
  data: {
    images: DailyLogEditProBackgroundImage[]
  }
}

export type DailyLogDiaryTypeItem = {
  type: DailyLogDiaryType
  icon: {
    emoji: string
    color: string
  }
  title: string
  description: string
  subdescription?: string
  ticker?: string
  gradientColors: string[]
  backgroundColor: string
}

export type DailyLogDiaryTypeDataListResponse = GenericResponse & {
  data: {
    postTypes: DailyLogDiaryTypeItem[]
  }
}

export type DailyLogTemplateListItem = {
  id: number
  title: string
  description: string
  bgImageUrl: string
  isPopular: boolean
  isBigBanner: boolean
}
export type DailyLogTemplateExampleBanner = {
  imageUrl: string
  title: string
  exampleId: number
}
export type DailyLogTemplatePaginatedListResponse = GenericPaginatedListResponse & {
  data: {
    templates: DailyLogTemplateListItem[]
    banner: DailyLogTemplateExampleBanner
  }
}

export type DailyLogPostListItem = {
  userId?: number
  type: DailyLogDiaryType
  keyword?: string
  link?: string
  id: number
  content: string
  postedAt: string
  imageUrl: string
  reactions: DailyLogReaction[]
  bgImageId?: number
  bgColor?: string
  template?: DailyLogTemplate
  name: string
}

export enum DailyLogPublicType {
  FRIEND = 'FRIEND',
  ANYONE = 'ANYONE',
  PRIVATE = 'PRIVATE',
}

export type DailyLogFriendProfilePost = DailyLogPostListItem & {}

export type DailyLogMyProfilePost = DailyLogPostListItem & {
  viewCount: number
  publicType: DailyLogPublicType
}

export type DailyLogMyPostListResponse = GenericPaginatedListResponse & {
  data: {
    logs: DailyLogMyProfilePost[]
    currentMonthlyCount: number
    totalLogCount: number
  }
}

export type DailyLogFriendProfilePostListResponse = GenericPaginatedListResponse & {
  data: {
    logs: DailyLogFriendProfilePost[]
    currentMonthlyCount: number
  }
}

export type DailyLogMetaData = {
  totalLogCount: number // n개의 기록
  totalLogPeriodDayCount: number // n일 동안
  isCreatedToday: boolean
  initMessages: string[]
}

export type DailyLogMetaDataResponse = GenericResponse & {
  data: DailyLogMetaData
}

export enum DailyLogChatRole {
  ASSISTANT = 'assistant',
  USER = 'user',
}

export enum DailyLogContentType {
  TEXT = 'text',
  IMAGE_URL = 'image_url',
  URL = 'url',
}

export type DailyLogChatMessage = {
  role: DailyLogChatRole
  content: string
  sentAt?: string
  isLast?: boolean // 마지막 메세지인지 여부
}

export type DailyLogPostCreateBody = {
  type: DailyLogDiaryType
  link?: string
  keyword?: string
  nickname?: string
  content: string
  image?: File | ''
  postedAt: string
  friendGroupIds?: number[]
  staticGroups?: Omit<FriendGroupType, 'CUSTOM'>[] // 'CONTACT' | 'SCHOOL' | 'FRIEND' |'ANYONE' 연락처, 타입스 친구, 학교 선택, 전체 공개 시
  deletionReservedAt?: string
  receiverIds?: number[]
  title?: string
  analysisResult?: DailyLogAnalysis
  bgImageId?: number
  bgColor?: string
  templateId?: number
  userIdentifier?: string
}

export type DailyLogChatData = {
  role: DailyLogChatRole
  content: string
  sentAt: string
  isPostGenerated?: boolean // 채팅 종료 후 일기 생성 결과일 경우에만 true
}

export type DailyLogCreateResponse = GenericResponse & {
  data: DailyLogChatData & DailyLogPost
}

export type DailyLogStickerListResponse = GenericPaginatedListResponse & {
  data: {
    stickers: DailyLogSticker[]
    totalCount: number
  }
}

export type DailyLogStickerResponse = GenericResponse & {
  data: DailyLogSticker
}
